import { Typography } from '@gympass/tai-chi/typography';
import type { CSSObject } from '@mui/material/styles';

import type { ThemeProps } from 'typings/styles';

import styled from '@mui/material/styles/styled';
import { excludeInvalidDOMProps } from 'utils/style';

export const Container = styled('div')(
  ({ theme }: ThemeProps) =>
    ({
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      gap: theme.spacing(5),
      maxWidth: '40rem',
      padding: theme.spacing(6),
      alignItems: 'center',
      justifyContent: 'center',
    } satisfies CSSObject),
);

type IllustrationStyleProps = { $maxWidth?: string };

export const Illustration = styled('figure', {
  shouldForwardProp: excludeInvalidDOMProps,
})<IllustrationStyleProps>(
  ({ theme, $maxWidth = '16rem' }) =>
    ({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '> svg': {
        height: 'auto',
        width: `min(100%, ${$maxWidth})`,
        [theme.breakpoints.up('md')]: {
          width: `min(100%, 25rem)`,
        },
      },
    } satisfies CSSObject),
);

export const Title = styled(Typography)(({ theme, isDisplay }) => ({
  ...theme.typography.h4,
  fontSize: theme.typography.h4.fontSize,
  fontFamily: isDisplay ? undefined : theme.typography.h1.fontFamily,
  [theme.breakpoints.up('md')]: {
    ...theme.typography.h2,
    fontFamily: isDisplay ? undefined : theme.typography.h3.fontFamily,
  },
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  fontWeight: 'normal',
  [theme.breakpoints.up('md')]: {
    ...theme.typography.h5,
    fontWeight: 'normal',
  },
}));
